import { useContext } from "react";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { Grid, Typography, Box, MenuItem, Select, Switch, TextField, Stack, Tabs, Tab, FormGroup, FormControlLabel, Checkbox, Button  } from "@mui/material";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

export const Variation = () => {
    const { setup_state } = useContext(ToolContext);
    const { switches } = setup_state;

    const handleVariationChange = (e) => {
        switches.set((p) => ({ ...p, variationSwitch: e.target.checked }))
    }

    const hndlListShppngChange = (e, newValue) => {
        switches.set((p) => ({ ...p, listShippingSwtch: newValue }))
    }
    const handleEnableImgChange = (e) => {
        switches.set((p) => ({ ...p, enableImgSwtch: e.target.checked }))
    }

    return (
        <>
            <Grid item xs={12} sx={{ display: "flex", alignItems: "center", mt: "1rem" }}>
                <Typography fontSize="0.875rem"> Enable Variation </Typography>
                <Switch onChange={handleVariationChange} checked={switches.data.variationSwitch} size="small"/>
            </Grid>
            { switches.data.variationSwitch ?
                <>
                    <Grid item xs={12}>
                        <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}> Variation Name <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                        <Select sx={{ width: "20rem" }} size="small">
                            <MenuItem> Litson Belly </MenuItem>
                            <MenuItem> Crispy Pata </MenuItem>
                            <MenuItem> Fried Chicken </MenuItem>
                            <MenuItem> Roasted Liempo </MenuItem>
                        </Select>
                    </Grid>
                    <Grid container item xs={12}>
                        <Grid item xs={12}>
                            <Stack flexDirection="row" alignItems="center" mb="0.5rem" gap="2rem">
                                <Typography fontSize="12px" sx={{ color: '#747C84' }}> Option <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                                <Stack flexDirection="row" alignItems="center">
                                    <Typography fontSize="12px" sx={{ color: '#747C84' }}> Enable Image </Typography>
                                    <Switch onChange={handleEnableImgChange} checked={switches.data.enableImgSwtch} size="small"/>
                                </Stack>
                            </Stack>
                        </Grid>
                        <Grid item xs={12} gap="1rem" sx={{ display: "flex", flexDirection: "row" }}>
                            { switches.data.enableImgSwtch &&  
                                <Box sx={{ border: "1px solid gray", width: "4rem", height: "100%", borderRadius: "4px"}}>
                                    
                                </Box>
                            }
                            <Stack flexDirection="row" alignItems="center" gap="0.5rem">
                                <TextField fullWidth size="small" InputLabelProps={{ sx: { fontSize: '0.9rem'} }}></TextField>
                                <DeleteOutlineIcon sx={{ fontSize: "2rem", cursor: "pointer", transition: "0.25s", ":hover": { color: "grey" } }}/>
                                <AddCircleOutlineIcon sx={{ fontSize: "1.75rem", cursor: "pointer", transition: "0.25s", ":hover": { color: "grey" } }}/>
                            </Stack>
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={2}>
                        <Grid item xs={12} mt="1.5rem">
                            <Tabs onChange={hndlListShppngChange} value={switches.data.listShippingSwtch} >
                                <Tab label="Variation List" value={1}/>
                                <Tab label="Shipping" value={2}/>
                            </Tabs>
                        </Grid>
                        <Grid item xs={1}>
                            <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}> Size <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                            <TextField fullWidth size="small"></TextField>
                        </Grid>
                        <Grid item xs={2.5}>
                            <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}> Product Variation Code <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                            <TextField fullWidth size="small"></TextField>
                        </Grid>
                        { switches.data.listShippingSwtch === 1 ?
                            <>
                                <Grid item xs={2}>
                                    <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}> Regular Price <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                                    <TextField fullWidth size="small"></TextField>
                                </Grid>
                                <Grid item xs={1}>
                                    <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}> Qty <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                                    <TextField fullWidth size="small"></TextField>
                                </Grid>
                                <Grid item xs={1.5}>
                                    <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}> Discount Type <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                                    <TextField fullWidth size="small"></TextField>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}> Discount <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                                    <TextField fullWidth size="small"></TextField>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}> Price <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                                    <TextField fullWidth size="small"></TextField>
                                </Grid>
                            </>
                        :
                            <>
                                <Grid item xs={2}>
                                    <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}> Weight in kg <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                                    <TextField fullWidth size="small"></TextField>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}> Height (cm) <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                                    <TextField fullWidth size="small"></TextField>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}> Width (cm) <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                                    <TextField fullWidth size="small"></TextField>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}> Length (cm) <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                                    <TextField fullWidth size="small"></TextField>
                                </Grid>
                            </>
                        }
                    </Grid>
                </>
            : 
                <>
                    <Grid item xs={3}>
                        <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}> Regular Price <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                        <TextField fullWidth size="small"></TextField>
                    </Grid>
                    <Grid item xs={1}>
                        <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}> Qty <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                        <TextField fullWidth size="small"></TextField>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}> Discount Type <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                        <TextField fullWidth size="small"></TextField>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}> Discount <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                        <TextField fullWidth size="small"></TextField>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}> Price <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                        <TextField fullWidth size="small"></TextField>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography mt="0.5rem" fontWeight="500"> Shipping </Typography>
                        <Typography fontSize="12px" my="0.5rem" sx={{ color: '#747C84' }} > Weight with Package<Box component="span" fontSize="12px" color="red">*</Box></Typography>
                        <Stack flexDirection="row" gap="1rem">
                        <Select sx={{ width: "12rem" }} size="small">
                            <MenuItem> Litson Belly </MenuItem>
                            <MenuItem> Crispy Pata </MenuItem>
                            <MenuItem> Fried Chicken </MenuItem>
                            <MenuItem> Roasted Liempo </MenuItem>
                        </Select>
                        <TextField sx={{ width: "15rem" }} size="small" label="Enter Product Weight" InputLabelProps={{ sx: { fontSize: '0.9rem'} }}></TextField>
                        </Stack>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography fontSize="12px" mb="0.5rem" sx={{ color: '#747C84' }}> Product Dimensions (cm) <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                        <Stack flexDirection="row" gap="1rem">
                            <TextField size="small" label="Height" InputLabelProps={{ sx: { fontSize: '0.9rem'} }}></TextField>
                            <TextField size="small" label="Width" InputLabelProps={{ sx: { fontSize: '0.9rem'} }}></TextField>
                            <TextField size="small" label="Length" InputLabelProps={{ sx: { fontSize: '0.9rem'} }}></TextField>
                        </Stack>
                    </Grid> 
                </>
            }
            <Grid item xs={12}>
                <Typography fontSize="12px" sx={{ color: '#747C84' }}> Show this Product <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                <FormGroup sx={{ display: "flex", flexDirection: "row", gap: "2rem" }}>
                    <FormControlLabel control={<Checkbox size="small"/>} label={<Typography fontSize="14px">POFShop</Typography>}/>
                    <FormControlLabel control={<Checkbox size="small"/>} label={<Typography fontSize="14px">Website / Store</Typography>}/>
                </FormGroup>
            </Grid>
            <Grid item xs={12} sx={{ display: "flex", justifyContent: "end" }}>
                <Box component={Button} variant="contained" fontSize={14} color="#fff" borderRadius={2} px={4} py={1} sx={{ ':hover': { bgcolor: '#009F4D', color: '#fff' } }} >Save and Close</Box>
            </Grid>
        </>
    )
}
